import { connect } from 'react-redux';

import pushURLHandler from 'shared/helpers/router/pushURLHandler';
import SubscriptionPaymentMethod from '../components/SubscriptionPaymentMethod';
import getResubscriptionCurrencies from '../../../../modules/page/selectors/getResubscriptionCurrencies';
import { PropsFromState, PropsFromDispatch } from '../types';
import { setSubscriptionCurrency } from '../../shared/actions/setSubscriptionCurrency';

function mapStateToProps(state: any): PropsFromState {
  const currencies = getResubscriptionCurrencies(state);

  return {
    currencies
  };
}

function mapDispatchToProps(dispatch: any): PropsFromDispatch {
  return {
    redirect: (url: string) => pushURLHandler(url)(dispatch),
    persistCurrency: (currency: string) =>
      dispatch(setSubscriptionCurrency(currency))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionPaymentMethod);
